import { render, staticRenderFns } from "./hotKeys.vue?vue&type=template&id=8177c432&scoped=true"
import script from "./hotKeys.vue?vue&type=script&lang=js"
export * from "./hotKeys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8177c432",
  null
  
)

export default component.exports